module.exports = __webpack_public_path__ + "nc_static/media/sw-accepted-icon.2da006f8.svg";